import Vue from 'vue';
import Router from 'vue-router';
import category from './category.vue';

Vue.use(Router);

const init = () => {
    return new Router({
        name: 'router',
        routes: [{
            path: '/:yearsFilter?',
            name: 'project-category',
            component: category,
            props(route) {
                const yearsFilter = route.params.yearsFilter || '';

                return {
                    yearsFilter: yearsFilter === '' ? [] : yearsFilter.split(',')
                }
            }
        }]
    });
};

export default {
    init
};


// WEBPACK FOOTER //
// ./src/js/modules/vueRouter.js